// extracted by mini-css-extract-plugin
export default {"subscription_item_price":"ZE","delete_item":"aF","subscription_item":"bF","subscription_item_img_wrapper":"cF","subscription_item_info":"eF","subscription_item_title":"fF","subscription_item_edit":"gF","subscription_item_wrapper":"hF","arrow":"iF","subscription_item_category":"jF","plus_button":"kF","more_details":"lF","old_price":"mF","discount":"nF"};
    if(module.hot) {
      // 1715632477984
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  